import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CandidateModule } from './candidate/candidate.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MyLoaderComponent } from './components/my-loader/my-loader.component';
import { MaintenanceOverlayComponent } from './components/maintenance-overlay/maintenance-overlay.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login-register/login-register.module';
import { OurTermsComponent } from './our-terms/our-terms.component';
import { AuthService } from './services/auth.service';
import { LoaderInterceptor } from './services/loader-interceptor.service';
import { LoaderService } from './services/loader.service';
import { TokenInterceptor } from './services/token.interceptor';
import { ServerErrorInterceptor } from './interceptors/server-error.interceptor';
import { SharedModule } from './shared/shared.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { OfflineBannerComponent } from './components/offline-banner/offline-banner.component';
import { RegenerateQuestionDialogComponent } from './components/regenerate-question-dialog/regenerate-question-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        WelcomeComponent,
        MyLoaderComponent,
        ConfirmDialogComponent,
        OurTermsComponent,
        SafeUrlPipe,
        OfflineBannerComponent,
        MaintenanceOverlayComponent,
        RegenerateQuestionDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HomeModule,
        LoginModule,
        DashboardModule,
        CandidateModule,
        SharedModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'fill' }
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerErrorInterceptor,
            multi: true
        },
        { provide: 'BASE_API_URL', useValue: environment.baseUrl },
        LoaderService,
        AuthService,
        DatePipe
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
